










































































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import CustomEditor from '../../../../../../Editor/CustomEditor'
import { SendMessageNode } from "../../../../SendMessage/logic/SendMessageNode";
import { SendMessageNodeProps } from '../../../../SendMessage/logic/types'
import { ActionNode } from '../../../logic/ActionNode'
import { ActionNodeActionProxy } from '../../../logic/Actions'
import { KickActionProxy } from '../../../logic/Actions/KickAction/KickActionProxy'
import { LabelsActionProxy } from '../../../logic/Actions/LabelsAction/LabelsActionProxy'
import { NotifyGroupActionProxy } from '../../../logic/Actions/NotifyGroupAction/NotifyGroupActionProxy'
import { NotifyUsersActionProxy } from '../../../logic/Actions/NotifyUsersAction/NotifyUsersActionProxy'
import { PropertyActionProxy } from '../../../logic/Actions/PropertyAction/PropertyActionProxy'
import { RemovePropertiesProxy } from '../../../logic/Actions/RemoveProperties/RemovePropertiesProxy'
import { ActionNodeProps } from '../../../logic/types'
import AddingAction from './AddingAction.vue'
import KickActionSidebar from './KickAction/KickActionSidebar.vue'
import LabelsAction from './LabelsAction.vue'
import NotifyGroupAction from './NotifyGroupAction/NotifyGroupAction.vue'
import NotifyUsersAction from './NotifyUsersAction/NotifyUsersAction.vue'
import PropertyAction from './PropertyAction/PropertyAction.vue'
import RemovePropertiesAction from './RemovePropertiesAction/RemovePropertiesAction.vue'

@Component({
  data() {
    return {
      KickActionProxy,
      LabelsActionProxy,
      NotifyGroupActionProxy,
      NotifyUsersActionProxy,
      PropertyActionProxy,
      RemovePropertiesProxy,
      snakeCase,
    }
  },
  components: {
    KickActionSidebar,
    RemovePropertiesAction,
    AddingAction,
    LabelsAction,
    NotifyGroupAction,
    NotifyUsersAction,
    PropertyAction,
  }
})
export default class ActionNodeActions extends Vue {
  @Prop() actions!: Array<ActionNodeActionProxy>

  @Prop() nodeProps!: ActionNodeProps | SendMessageNodeProps

  @Prop() node!: ActionNode | SendMessageNode

  @Prop() editor!: CustomEditor

  @Prop() creatingOutputs!: boolean

  @Emit()
  removeAction(action: ActionNodeActionProxy): ActionNodeActionProxy {
    return action
  }

  get placeholders() {
    if (typeof this.nodeProps.placeholders === 'function') {
      return this.nodeProps.placeholders()
    } else {
      return []
    }
  }
}
